import React, { useEffect, useState, useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import './faqPage.scss'; // Import CSS file for styling if needed
import { LanguageContext } from '../../services/LanguageContext'; // Import LanguageContext for checking the language
import { translateText } from '../../services/deeplTranslationService'; // Import translation service

const FaqPage = () => {
    const { language } = useContext(LanguageContext); // Get the current language from context
    const [faqs, setFaqs] = useState([]);
    const [translatedFaqs, setTranslatedFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    // Translatable UI elements
    const [helpTitle, setHelpTitle] = useState('Brauchst du Hilfe?');
    const [searchPlaceholder, setSearchPlaceholder] = useState('Gib hier deine Frage ein...');
    const [faqTitle, setFaqTitle] = useState('Häufig gestellte Fragen');
    const [loadingMessage, setLoadingMessage] = useState('FAQs werden geladen...');
    const [noFaqMessage, setNoFaqMessage] = useState('Keine FAQs gefunden. Bitte besuchen Sie unsere Kontaktseite für weitere Unterstützung.');

    useEffect(() => {
        const translateUI = async () => {
            if (language !== 'DE') {
                const translatedHelpTitle = await translateText('Brauchst du Hilfe?', language);
                const translatedSearchPlaceholder = await translateText('Gib hier deine Frage ein...', language);
                const translatedFaqTitle = await translateText('Häufig gestellte Fragen', language);
                const translatedLoadingMessage = await translateText('FAQs werden geladen...', language);
                const translatedNoFaqMessage = await translateText('Keine FAQs gefunden. Bitte besuchen Sie unsere Kontaktseite für weitere Unterstützung.', language);

                setHelpTitle(translatedHelpTitle);
                setSearchPlaceholder(translatedSearchPlaceholder);
                setFaqTitle(translatedFaqTitle);
                setLoadingMessage(translatedLoadingMessage);
                setNoFaqMessage(translatedNoFaqMessage);
            }
        };

        translateUI();
    }, [language]);

    useEffect(() => {
        // Fetch FAQs from the API
        const fetchFaqs = async () => {
            try {
                const response = await fetch('https://find-together-api.sslbeta.de/api/Support/getFAQs');
                const data = await response.json();
                setFaqs(data);

                // If the language is not German, translate the FAQs
                if (language !== 'DE') {
                    const translatedData = await Promise.all(
                        data.map(async (faq) => ({
                            question: await translateText(faq.question, language),
                            answer: await translateText(faq.answer, language),
                        }))
                    );
                    setTranslatedFaqs(translatedData);
                } else {
                    // Use original data if the language is German
                    setTranslatedFaqs(data);
                }
            } catch (error) {
                console.error('Error fetching FAQs:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchFaqs();
    }, [language]);

    // Filter FAQs based on search term
    const filteredFaqs = translatedFaqs.filter(faq =>
        faq.question.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className='container inner-page-container'>
            <div className="help-search">
                <h2>{helpTitle}</h2>
                <input
                    type="text"
                    placeholder={searchPlaceholder}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="help-search-input"
                />
            </div>
            <h2 className='text-left my-5'>{faqTitle}</h2>
            {loading ? (
                <p className='text-center'>{loadingMessage}</p>
            ) : (
                <>
                    {filteredFaqs.length > 0 ? (
                        <Accordion>
                            {filteredFaqs.map((faq, index) => (
                                <Accordion.Item key={index} eventKey={index.toString()}>
                                    <Accordion.Header>{faq.question}</Accordion.Header>
                                    <Accordion.Body>{faq.answer}</Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    ) : (
                        <p className='text-center'>{noFaqMessage} <a href="/contact">Kontaktseite</a> für weitere Unterstützung.</p>
                    )}
                </>
            )}
        </div>
    );
};

export default FaqPage;
